<template>
	<table-tool
		:show-step="false"
		:rotated-card="rotate"
	>
		<information
			title="Descripción"
			:description="selectedSupply.description"
			:name="selectedSupply.name"
		/>
		<div
			slot="footer"
			class="tw-w-full tw-flex tw-justify-center">
			<v-btn
				type="button"
				small
				class="custom-button"
				color="primary"
				@click="goBack"
			>
				Atrás
			</v-btn>
		</div>
	</table-tool>
</template>

<script>
import tableTool from '@/components/surveys/graphic-factors';
import information from '@/components/diagnosis/information';

export default {
	name: 'supply-card-detail',
	components: { tableTool, information },
	props: ['titleTable', 'rotate', 'selectedSupply'],
	methods: {
		goBack() {
			this.goTo('job-evaluation-new');
		},
	},
};
</script>

<style lang='scss' scoped>
	.information-text {
		p {
			margin-bottom: 20px !important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/supply-card-detail.vue